import React from 'react'
import Slider from 'react-slick'
import { Text, SlidePortifolio } from '../../common/styled'
import mediaQuery from '../../common/mediaQuery'
import '../style.css';


export default ({ text }) => {

  const { large, small } = mediaQuery()

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    className: 'SliderContainer',
    slide: 'SlidePortifolio',
    appendDots: dots => (
      <ul style={{ margin: "5px", backgroundColor: '#22222200', paddingTop: 0, paddingBottom: 0 }}> {dots} </ul>
    ),
    customPaging: i => (
      <div style={ { 
        width: "15px",
        height: "15px",
        backgroundColor: "#ffffff00",
        opacity: 1,
        border: "1px white solid",
        borderRadius: "50%",
        padding: "1px",
        display: "flex",
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 2
      } }>
        <div class="Dot" style={{ 
          border: "0px #ffffff00 solid",
          borderRadius: "50%",
          width: "11px",
          height: "11px",
          opacity: 0,
          backgroundColor: "#fff",
        }} />
      </div>
    )
  };
  
  const portifolio = [];

  text.getTextoPortifolio().map(obj => {
    portifolio.push({ imagem: obj.imagem, texto: obj.texto })
  })

/*  const portifolio = [
    { imagem: require(`../../../images/portifolio/fiscalizavr.jpg`), texto: text.getTextoPortifolio()[0] },
    { imagem: require(`../../../images/portifolio/queimados.jpg`), texto: text.getTextoPortifolio()[1] },
    { imagem: require(`../../../images/portifolio/fiscaliza.jpg`), texto: text.getTextoPortifolio()[2] },
    { imagem: require(`../../../images/portifolio/japeri.jpg`), texto: text.getTextoPortifolio()[3] }
  ]
*/

  return (
    <div className="SliderContainer">
      <Slider {...settings}>
            { portifolio.map(obj => {
                return (
                  <div>
                    <div className="SlideContato" style={{ 
                    backgroundImage: `url(${obj.imagem})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center' 
                  }}>
                      <div className="SlideText" style={small ? {} : {}}>
                        <Text weight="700" size={small ? "2.5vh" : large ? "1.8vw" : "2.5vw"} align="left">
                          { obj.texto }
                        </Text>
                      </div>
                    </div>
                  </div>     
                )
            })
            }
      </Slider>
    </div>
  )
}